import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { ChevronDown, Calendar as CalendarIcon, Users, Baby } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { format } from 'date-fns';

const banners = [
  "/static/images/resortExterior.jpg",
  "/static/images/resortExterior2.jpg",
  "/static/images/resortExterior4.jpg",
];

const Hero = ({ onCheckAvailability, checkIn, setCheckIn, checkOut, setCheckOut, adults, setAdults, kids, setKids }) => {
  const [checkInOpen, setCheckInOpen] = useState(false);
  const [checkOutOpen, setCheckOutOpen] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleCheckAvailability = () => {
    // if (checkIn && checkOut && onCheckAvailability) {
    //   onCheckAvailability();
    // }
    window.location.href = "https://www.zotel.ai/hotels/luxtansa-resort";
  };

  const handleCheckInSelect = (date) => {
    setCheckIn(date);
    setCheckInOpen(false);
  };

  const handleCheckOutSelect = (date) => {
    setCheckOut(date);
    setCheckOutOpen(false);
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <img
          src={`${process.env.PUBLIC_URL + "/static/images/resortExterior.jpeg"}`}
          alt="Luxtansa Resorts"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          Welcome to <span className="hero-highlight">Luxtansa</span>
        </h1>
        <p className="hero-subtitle">
          Where Luxury Meets Tranquility
        </p>
        <p className="hero-description">
          Escape to a world of elegance and natural beauty. Experience exceptional hospitality,
          world-class amenities, and breathtaking countryside views.
        </p>

        {/* Availability Checker */}
        {/* <div className="availability-checker"> */}
          {/* <div className="availability-row"> */}
            {/* <div className="availability-field">
              <label className="availability-label">
                <CalendarIcon size={18} />
                Check-in
              </label>
              <Popover open={checkInOpen} onOpenChange={setCheckInOpen}>
                <PopoverTrigger asChild>
                  <Button variant="outline" className="availability-date-button">
                    {checkIn ? format(checkIn, 'MMM dd, yyyy') : 'Select date'}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    selected={checkIn}
                    onSelect={handleCheckInSelect}
                    disabled={(date) => {
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      return date < today;
                    }}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
            </div> */}

            {/* <div className="availability-field">
              <label className="availability-label">
                <CalendarIcon size={18} />
                Check-out
              </label>
              <Popover open={checkOutOpen} onOpenChange={setCheckOutOpen}>
                <PopoverTrigger asChild>
                  <Button variant="outline" className="availability-date-button">
                    {checkOut ? format(checkOut, 'MMM dd, yyyy') : 'Select date'}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    selected={checkOut}
                    onSelect={handleCheckOutSelect}
                    disabled={(date) => {
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      if (date < today) return true;
                      if (checkIn) {
                        const nextDay = new Date(checkIn);
                        nextDay.setDate(nextDay.getDate() + 1);
                        nextDay.setHours(0, 0, 0, 0);
                        return date < nextDay;
                      }
                      return false;
                    }}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
            </div> */}

            {/* <div className="availability-field">
              <label className="availability-label">
                <Users size={18} />
                Adults
              </label>
              <Select value={adults} onValueChange={setAdults}>
                <SelectTrigger className="availability-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[1, 2, 3, 4, 5, 6].map((num) => (
                    <SelectItem key={num} value={num.toString()}>
                      {num} {num === 1 ? 'Adult' : 'Adults'}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div> */}

            {/* <div className="availability-field">
              <label className="availability-label">
                <Baby size={18} />
                Kids
              </label>
              <Select value={kids} onValueChange={setKids}>
                <SelectTrigger className="availability-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[0, 1, 2, 3, 4].map((num) => (
                    <SelectItem key={num} value={num.toString()}>
                      {num} {num === 1 ? 'Kid' : 'Kids'}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div> */}

            <Button onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })} className="availability-cta"
            // disabled={!checkIn || !checkOut}
            >
              Book Now
            </Button>
          {/* </div> */}
        {/* </div> */}

        <div className="hero-buttons">
          <Button
            onClick={() => document.getElementById('facilities')?.scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="hero-cta-secondary"
          >
            Explore Facilities
          </Button>
        </div>
      </div>

      <button
        className="scroll-indicator"
        onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
